import React, { Suspense, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Group from "./containers/Group";
import Landing from "./containers/Landing";
import CreateGroup from "./containers/CreateGroup";
import ErrorBoundary from "./containers/ErrorBoundary";
import Terms from "./containers/Terms";
import Games from "./games/Games";
import GameCategories from "./games/GameCategories";
import CreateTexasRoom from "./games/texas/CreateTexasRoom";
import TexasRoom from "./games/texas/TexasRoom";
import TexasSeat from "./games/texas/TexasSeat";
import CreateJubenshaRoom from "./games/jubensha/CreateJubenshaRoom";
import JubenshaRoom from "./games/jubensha/JubenshaRoom";
import JubenshaSeat from "./games/jubensha/JubenshaSeat";
import GroupIsland from "./containers/GroupIsland";
import ImagesLanding from "./containers/ImagesLanding";
import Chat from "./containers/Chat";
import LoadingIndicator from "./components/LoadingIndicator";
import ReturnDonationModal from "./components/ReturnDonationModal";
import ErrorModals from "./components/ErrorModals";
import VenmoFallbackModal from "./components/VenmoFallbackModal";
import { SceneProvider } from "./components/scene/SceneContext";

function App() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <ErrorBoundary>
      <Suspense fallback="loading">
        <SceneProvider>
          <Router
            basename={
              process.env.NODE_ENV === "development" ? "/" : "/"
            }
          >
            <div>
              <Switch>
                <Route path={`${process.env.PUBLIC_URL}/terms`}>
                  <Terms />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/chat`}>
                  <Chat />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/texas/new`}>
                  <CreateTexasRoom />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/texas/:room_id/seat/:seat_index?`}>
                  <TexasSeat />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/texas/:room_id`}>
                  <TexasRoom />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/jubensha/new`}>
                  <CreateJubenshaRoom />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/jubensha/:room_id/seat/:seat_index?`}>
                  <JubenshaSeat />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/jubensha/:room_id`}>
                  <JubenshaRoom />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games/categories`}>
                  <GameCategories />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/games`}>
                  <Games />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/images`}>
                  <ImagesLanding />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/group/new`}>
                  <CreateGroup setIsLoading={setIsLoading} />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/group/:group_id/island`}>
                  <GroupIsland setIsLoading={setIsLoading} />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/group/:group_id`}>
                  <Group setIsLoading={setIsLoading} />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/`}>
                  <Landing />
                </Route>
              </Switch>
              <ReturnDonationModal />
              <ErrorModals />
              <VenmoFallbackModal />
              <LoadingIndicator loading={isLoading} />
            </div>
          </Router>
        </SceneProvider>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
